var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jsf-form-item',{attrs:{"label":_vm.schema.title || _vm.path,"error":_vm.errorMessage,"required":_vm.required,"schema":_vm.schema}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }